/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "bell-88e810e1--sprite",
  "use": "bell-88e810e1--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"bell-88e810e1--sprite\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 1h-2v2.07A7.002 7.002 0 005 10v5l-2 3v2h18v-2l-2-3v-5a7.002 7.002 0 00-6-6.93V1zM7 15.606L5.404 18h13.192L17 15.606V10a5 5 0 00-10 0v5.606z\" fill=\"currentColor\" /><path d=\"M14 22a2 2 0 11-4 0h4z\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
